import { Filter, Datagrid, useTranslate, FunctionField, List, TextInput, Pagination, ReferenceField, TextField, useListContext, useLocaleState, ReferenceInput, AutocompleteInput, NumberInput, DateField, Button } from 'react-admin'
import { autocompleteInputCommonStyle, datagridCommonStyle, listActionsColumnIconCommonStyle, listCommonStyle, searchInputCommonStyle } from '../../../themes/commonStyles'
import { LIST_TYPE_TABLE } from '../../../ui/button/ListTypeButton';
import { useTheme, Box, Typography, Tooltip } from '@mui/material';
import { isSuperAdmin } from '../../../helper/resourceHelper'
import SearchInputLabelComponent from '../../../ui/inputs/SearchInputLabelComponent';
import LoadingDialog from '../../../ui/dialog/LoadingDialog';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';
import { useNavigate } from 'react-router-dom';





const Icon = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye-search">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
            <path d="M12 18c-.328 0 -.652 -.017 -.97 -.05c-3.172 -.332 -5.85 -2.315 -8.03 -5.95c2.4 -4 5.4 -6 9 -6c3.465 0 6.374 1.853 8.727 5.558" />
            <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M20.2 20.2l1.8 1.8" />
        </svg>

    )
}



const VoucherBatchListActions = () => {
    return (
        <Box sx={{
            display: "flex",
            flexDirection: "row"

        }}>
        </Box>
    )
}



const VoucherBatchListPagination = ({ }) => {

    return (<Pagination sx={{
        '& .MuiToolbar-root': {
            borderTopRightRadius: "0px",
            borderTopLeftRadius: "0px",
            borderBottomRightRadius: "12px",
            borderBottomLeftRadius: "12px",
            marginTop: "0px",

        }

    }} rowsPerPageOptions={[10, 25, 50, 100, 500]} />)
};

const LoadingPopUp = ({ }) => {
    const { isPending, isFetching, isLoading } = useListContext();
    return (
        <LoadingDialog
            isPending={isPending}
            isFetching={isFetching}
            isLoading={isLoading}
        />
    )

};


const GoToFilteredVouchers = ({ batchNumber }) => {
    const navigate = useNavigate();
    const translate = useTranslate();
    const theme = useTheme();

    const handleClick = () => {
        const filter = JSON.stringify({ batch_number: batchNumber });
        navigate(`/vouchers?filter=${encodeURIComponent(filter)}`);
    };

    return (

        <Tooltip title={translate('resources.vouchers.view_associated_vouchers')}  >
            <Button
                onClick={handleClick}
                sx={listActionsColumnIconCommonStyle({ isLastItem: false })}
            >
                <Icon color={theme.palette.primary.main} />
            </Button>
        </Tooltip>
    )

};


const VoucherBatchList = props => {
    const [locale, setLocale] = useLocaleState();
    const theme = useTheme();
    const translate = useTranslate();
    const navigate = useNavigate();

    return (
        <>


            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.vouchers.voucher_batches')}
            </Typography>
            <List
                actions={<VoucherBatchListActions />}
                filter={{ includes: 'plan', language: locale ? locale : "en" }}
                filters={
                    <Filter  {...props}>
                        <TextInput
                            id="outlined-basic-size-small"
                            label={<SearchInputLabelComponent />}
                            source="q"
                            alwaysOn
                            sx={searchInputCommonStyle({ theme })}
                        />

                        <TextInput
                            id="outlined-basic-size-small"
                            label="resources.vouchers.fields.batch_number"
                            source="batch_number"
                            alwaysOn
                            sx={searchInputCommonStyle({ theme })}
                        />

                        {isSuperAdmin() && <ReferenceInput source="root_organization_id" reference="root_organizations" alwaysOn >
                            <AutocompleteInput
                                id="outlined-basic-size-small"
                                disablePortal
                                optionText="name"
                                matchSuggestion={() => true} label="resources.vouchers.fields.root_organization"
                                sx={autocompleteInputCommonStyle({ theme })}
                            />
                        </ReferenceInput>}
                    </Filter>

                }
                sx={listCommonStyle({ isLargeOrLess: false, listFormat: LIST_TYPE_TABLE, theme })}
                perPage={25}
                sort={{ field: 'creation_date', order: 'DESC' }}
                pagination={false}
            >

                <Datagrid
                    bulkActionButtons={false}
                    size='small'
                    sx={datagridCommonStyle({ theme })}
                >


                    <TextField
                        source="batch_id"
                        label={translate('resources.vouchers.fields.batch_number')}
                        sortable={false}
                    />
                    <TextField
                        source="batch_description"
                        label={translate('resources.vouchers.fields.description')}
                        sortable={false}
                    />
                    <TextField
                        source="voucher_count"
                        label={translate('resources.vouchers.fields.voucher_count')}
                        sortable={false}
                    />

                    <DateField
                        source="creation_date"
                        locales={locale}
                        label={translate('resources.vouchers.fields.creation_date')}
                        sortable={false}
                        options={{
                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false,
                        }}
                    />

                    <ReferenceField source="root_organization_id" reference="root_organizations" allowEmpty>
                        <FunctionField
                            render={record => record.name ? record.name.toUpperCase() : record.id}
                            sortable={false}
                        />
                    </ReferenceField>

                    <FunctionField
                        label={translate('resources.devices.fields.actions', { smart_count: 1 })}
                        render={record => <GoToFilteredVouchers batchNumber={record?.batch_id} />}
                    />

                </Datagrid>
                <VoucherBatchListPagination />
                <LoadingPopUp />
            </List>
        </>
    )

}


export default VoucherBatchList;